import React from 'react';

import PropTypes from 'prop-types';

import { normalizeReferenceValue } from '../utils';
import TextFieldField from './TextFieldField';

const ReferenceField = ({
  data, value, disabled, isDiff, onChange, textPlaceholder,
}) => (
  <TextFieldField
    data={data}
    value={normalizeReferenceValue(value)}
    disabled={disabled}
    isDiff={isDiff}
    placeholder={textPlaceholder}
    onChange={onChange}
  />
);

ReferenceField.propTypes = {
  data: PropTypes.shape({ title: PropTypes.string }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  disabled: PropTypes.bool,
  isDiff: PropTypes.bool,
  textPlaceholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

ReferenceField.defaultProps = {
  value: '',
  disabled: false,
  isDiff: false,
  textPlaceholder: '',
};

export default ReferenceField;
